"use client";

import { useMemo } from "react";
import { cx } from "@/components";
import { qrMatrix } from "./qr";

export interface QrCodeProps {
  /** The URL/text to encode (share links are far below the size ceiling). */
  text: string;
  size?: number;
  className?: string;
}

/** Scannable QR of the share link — SVG modules in token colors. */
export function QrCode({ text, size = 116, className }: QrCodeProps) {
  const matrix = useMemo(() => {
    try {
      return qrMatrix(text);
    } catch {
      return null; // over-long payload — render nothing rather than a broken code
    }
  }, [text]);

  if (!matrix) return null;
  const n = matrix.length;
  let d = "";
  matrix.forEach((row, y) =>
    row.forEach((cell, x) => {
      if (cell) d += `M${x} ${y}h1v1h-1z`;
    }),
  );

  return (
    <svg
      width={size}
      height={size}
      viewBox={`-2 -2 ${n + 4} ${n + 4}`}
      role="img"
      aria-label="QR code for the share link"
      shapeRendering="crispEdges"
      className={cx("share-qrsvg", className)}
    >
      <rect x={-2} y={-2} width={n + 4} height={n + 4} fill="var(--color-surface-raised)" />
      <path d={d} fill="var(--color-text-primary)" />
    </svg>
  );
}
